var path = '/pages/queue/views/list.tpl.html';
var html = "<listview ng-if=\"vm.store\" store=\"vm.store\"></listview>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/queue/views/list.tpl.html
// module id = 2304
// module chunks = 1